module.exports = __webpack_public_path__ + "img/bronze.75ea7d2b.svg";